var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PasswordVerification',{attrs:{"is-dark":true,"solo":true,"outlined":false,"icon-enabled":true},on:{"verifypassword":_vm.onVerifyPassword}})
}
var staticRenderFns = []

export { render, staticRenderFns }